import React from "react";
import Frame from "../components/Frame";
import EventTile from "../components/EventTile";
import { EVENTS } from "../lib/events";

export const Events = () => {
  return (
    <div className="sc-page sc-page-events" data-testid="page-events">
      <Frame as="section" className="sc-page-hero" testId="events-hero">
        <span className="sc-section-eyebrow">OUR EXPERIENCES</span>
        <h1 className="sc-page-title">Choose your celebration</h1>
        <p className="sc-page-sub">
          Each experience begins with a tailored online enquiry. Select the
          celebration that suits you and we&rsquo;ll return within 48 hours
          with a personalised quote.
        </p>
      </Frame>

      <Frame as="section" className="sc-events" testId="events-grid-section">
        <div className="sc-tiles-grid" data-testid="event-tiles-grid">
          {EVENTS.map((ev, i) => (
            <EventTile event={ev} index={i} key={ev.slug} />
          ))}
        </div>
      </Frame>

      <Frame as="section" className="sc-cta" testId="events-cta">
        <h2 className="sc-cta-title">Not sure which is right?</h2>
        <p className="sc-cta-sub">
          We&rsquo;re happy to talk it through. Send us a note and we&rsquo;ll
          help you find the perfect fit.
        </p>
        <div className="sc-cta-btns">
          <a
            href="mailto:sunstatecollective@gmail.com"
            className="sc-btn-primary"
          >
            EMAIL US
          </a>
        </div>
      </Frame>
    </div>
  );
};

export default Events;
